
import { ATTR_TYPES } from './dataDefinition.js';

const DEFINITION_TEL = {
    objectType: 'tel',
    tableName: 'iskn_telesa',
    title: 'Listy vlastnictví',
    attributes: [
        {
            id: 'id',
            type: ATTR_TYPES.STRING,
            title: 'ID tělesa'
        },
        {
            id: 'katuze_kod',
            type: ATTR_TYPES.INTEGER,
            title: 'Kód katastrálního území'
        },
        {
            id: 'cislo_tel',
            type: ATTR_TYPES.INTEGER,
            title: 'Číslo LV'
        }
    ]
};

export {
    DEFINITION_TEL
};
